import { render, staticRenderFns } from "./PhoneCodeIcon.vue?vue&type=template&id=13f8ef50"
import script from "./PhoneCodeIcon.vue?vue&type=script&lang=js"
export * from "./PhoneCodeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports